export {MessagesViewportRequest as default};

/**
* Messages Viewport Request
*
* Defines Horde Messages Viewport request params
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class MessagesViewportRequest {
  /**
   * Folder view id
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {String}
   */
  view;

  /**
   * Defines if it's the first viewport request for given view
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Number} 0|1
   */
  initial;

  /**
   * Force Cache
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Number} 0 don't force cache, 1 force cache
   */
  force;

  /**
   * Slice size
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {String}
   */
  slice;

  /**
   * Cache id
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {String}
   */
  cacheid;

  /**
   * Messages id in cache
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Array}
   */
  cache;

  /**
   * Defines if cache should be checked
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Number} 0 no cache, 1 cache
   */
  checkcache;

  /**
   * Search Value
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {String}
   */
   qsearch;

  /**
   * Search Field
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {String}
   */
  qsearchfield;

  /**
   * Mbox search
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {String}
   */
  qsearchmbox;

  /**
   * Search Filter
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {String}
   */
  qsearchfilter;

  /**
   * Search Flag
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {String}
   */
  qsearchflag;

  /**
   * Defines sort direction
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Number}
   */
  sortdir;

  /**
   * Defines sort by
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Number}
   */
   sortby;
}